export enum CloudAssetQueryKey {
    CloudAssetDetails = "cloud-asset-details",
    CloudProxies = "cloud-asset-proxies",
    CloudAssetPreview = "cloud-asset-preview",
    CloudAssetOperations = "cloud-asset-operations",
    ConformingCloudAssets = "conforming-cloud-assets"
}
